import React, { ErrorInfo, ReactNode } from 'react';
import { connect } from 'react-redux';
import { Button } from 'ui-redesign/Button';
import Sad from 'assets/gifs/sad.gif';
import { getTranslate } from 'react-localize-redux';

// Define interfaces
interface ErrorBoundaryProps {
  children: ReactNode;
  t: (key: string) => string;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error(error);
    console.error(errorInfo);
  }

  render(): ReactNode {
    const { t } = this.props;

    if (this.state.hasError) {
      const handleReload = (): void => {
        window.location.reload();
      };

      return (
        <div
          style={{
            padding: '20px',
            display: 'flex',
            justifyContent: 'center',
            height: '85%',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
            <h1 style={{ margin: 0 }}>{t('common.somethingWentWrong')}</h1>
            <img src={Sad} alt=":(" />
          </div>
          <Button
            variant="caution"
            style={{ marginTop: '16px' }}
            onClick={handleReload}
          >
            {t('common.reloadPage')}
          </Button>
        </div>
      );
    }

    return this.props.children;
  }
}

const mapStateToProps = (state: any) => ({
  t: getTranslate(state.locale),
});

export default connect(mapStateToProps)(ErrorBoundary);
